// RPI结果计算工具

// RPI等级定义
export const RPI_LEVELS = [
  { min: 0, max: 20, level: '很低（自由自在）', color: 'blue', emoji: '🦋' },
  { min: 20, max: 40, level: '偏低（松弛有度）', color: 'sky', emoji: '🌿' },
  { min: 40, max: 60, level: '中等（恰到好处）', color: 'yellow', emoji: '⚖️' },
  { min: 60, max: 80, level: '偏高（执着深情）', color: 'orange', emoji: '🔥' },
  { min: 80, max: 101, level: '很高（爱到极致）', color: 'red', emoji: '💝' }
]

// 16种恋爱占有欲人格类型定义
export const PERSONALITY_TYPES = {
  free_spirit: {
    id: "free_spirit",
    name: "自由灵魂型",
    emoji: "🦋",
    description: "给予伴侣充分自由，信任对方的选择，享受独立而亲密的关系。",
    characteristics: ["极少控制行为", "几乎不嫉妒", "情感独立", "安全感强"],
    strengths: ["给予伴侣充分的自由空间", "信任感强，关系轻松", "个人成长与关系并重", "情绪稳定成熟"],
    challenges: ["可能被误解为不够在乎", "需要注意表达爱意", "要避免过度疏离"],
    advice: "记得主动表达爱和关心，让伴侣感受到你的重视。自由不等于冷漠，适度的关注会让关系更温暖。",
    color: "#3b82f6"
  },
  balanced_trust: {
    id: "balanced_trust",
    name: "平衡信任型",
    emoji: "⚖️",
    description: "在自由与关心之间保持良好平衡，既信任伴侣又保持适度关注。",
    characteristics: ["控制欲低", "嫉妒少见", "适度依赖", "基本安全"],
    strengths: ["平衡亲密与独立", "信任与关心兼顾", "关系健康稳定", "沟通成熟理性"],
    challenges: ["需要保持现有平衡", "注意伴侣的情感需求"],
    advice: "你的关系模式很健康！继续保持开放沟通，定期与伴侣确认彼此的感受和需求。",
    color: "#0ea5e9"
  },
  rational_observer: {
    id: "rational_observer",
    name: "理性观察型",
    emoji: "🧠",
    description: "用理性思维管理情绪，控制占有欲，但有时显得理智过头。",
    characteristics: ["理性控制情绪", "很少情绪化", "独立性强", "相对冷静"],
    strengths: ["情绪管理能力强", "不会无理取闹", "给伴侣自由空间", "理性解决问题"],
    challenges: ["可能过度压抑情感", "需要学会表达脆弱", "避免情感疏离"],
    advice: "适度展现你的情感需求和脆弱面，理性很好，但不要忘记爱情也需要感性和热度。",
    color: "#06b6d4"
  },
  gentle_companion: {
    id: "gentle_companion",
    name: "温柔陪伴型",
    emoji: "🌸",
    description: "温柔体贴，信任伴侣，不会过度干涉，是理想的恋爱伙伴。",
    characteristics: ["温柔不控制", "信任为先", "情感成熟", "关系和谐"],
    strengths: ["温暖体贴的陪伴", "高度信任伴侣", "尊重个人空间", "情感表达恰当"],
    challenges: ["注意不要过度迁就", "该坚持的边界要坚持"],
    advice: "你是很好的伴侣！记得在温柔的同时保持自我，健康的关系需要两个完整的个体。",
    color: "#6366f1"
  },
  mild_protector: {
    id: "mild_protector",
    name: "轻度保护型",
    emoji: "🛡️",
    description: "适度关注伴侣动态，偶尔会有小担忧，但整体可控。",
    characteristics: ["轻微控制倾向", "偶尔嫉妒", "适度依赖", "小小不安"],
    strengths: ["关心不过度", "在乎但不控制", "情绪基本稳定"],
    challenges: ["注意嫉妒情绪", "避免过度担忧", "培养更多信任"],
    advice: "你的占有欲在健康范围，继续练习信任和自我觉察，当不安出现时深呼吸并理性思考。",
    color: "#eab308"
  },
  caring_worrier: {
    id: "caring_worrier",
    name: "关心忧虑型",
    emoji: "💚",
    description: "深深在乎伴侣，有时会担心过度，需要学习放松。",
    characteristics: ["关心略过度", "容易担忧", "情感需求高", "需要安慰"],
    strengths: ["非常在乎对方", "情感投入度高", "愿意为关系努力"],
    challenges: ["容易过度担心", "需要更多安全感", "学习自我安慰"],
    advice: "你的在乎很珍贵，但要学会管理焦虑。建立自己的情感支持系统，不要只依赖伴侣。",
    color: "#f59e0b"
  },
  selective_jealous: {
    id: "selective_jealous",
    name: "选择性嫉妒型",
    emoji: "👀",
    description: "在特定情境下会嫉妒，但整体尚能理性控制。",
    characteristics: ["特定场景嫉妒", "控制欲一般", "依赖适中", "有时不安"],
    strengths: ["能识别嫉妒触发点", "大部分时候理性", "愿意自我改善"],
    challenges: ["管理特定触发情境", "避免情绪爆发", "提升自我价值感"],
    advice: "识别是什么触发你的嫉妒，是异性、前任还是其他？理解根源才能对症下药。",
    color: "#fb923c"
  },
  insecure_seeker: {
    id: "insecure_seeker",
    name: "不安寻求型",
    emoji: "🥺",
    description: "内心不安全感较强，需要频繁确认伴侣的爱，但不会过度控制。",
    characteristics: ["不安全感明显", "需要确认", "依赖倾向", "控制较少"],
    strengths: ["坦诚表达需求", "不隐藏脆弱", "愿意寻求支持"],
    challenges: ["建立内在安全感", "减少过度确认", "培养自我价值"],
    advice: "你的不安可能源于过往经历。考虑心理咨询，从根源上建立安全感，而非依赖外部确认。",
    color: "#f97316"
  },
  passionate_lover: {
    id: "passionate_lover",
    name: "热情深情型",
    emoji: "❤️‍🔥",
    description: "爱得炽烈，占有欲明显但可控，需要学习给彼此空间。",
    characteristics: ["控制欲较强", "嫉妒频繁", "依恋深度", "不安感高"],
    strengths: ["爱得深沉投入", "忠诚度极高", "情感表达强烈"],
    challenges: ["容易占有过度", "给伴侣压力", "需要冷静空间"],
    advice: "你的爱很浓烈，但要记得爱不是占有。给彼此空间，信任是爱的基础，控制只会推开对方。",
    color: "#e11d48"
  },
  anxious_attacher: {
    id: "anxious_attacher",
    name: "焦虑依恋型",
    emoji: "😰",
    description: "焦虑型依恋模式，极度害怕被抛弃，情感依赖强。",
    characteristics: ["极度依赖", "害怕抛弃", "情绪波动大", "需要陪伴"],
    strengths: ["情感敏感细腻", "重视关系", "愿意付出"],
    challenges: ["过度依赖伴侣", "情绪消耗大", "需要建立安全型依恋"],
    advice: "你的依恋模式可能来自童年。学习独立和自我安慰，阅读《依恋理论》相关书籍会有帮助。",
    color: "#db2777"
  },
  jealous_guardian: {
    id: "jealous_guardian",
    name: "嫉妒守护型",
    emoji: "💢",
    description: "嫉妒心强，常常担心失去伴侣，需要大量安全感。",
    characteristics: ["嫉妒强烈", "警惕性高", "占有明显", "信任困难"],
    strengths: ["对关系警觉", "忠诚专一", "在意伴侣"],
    challenges: ["嫉妒影响生活", "伴侣感到窒息", "建立信任机制"],
    advice: "嫉妒源于不安和不信任。问自己：过去的经历如何影响了现在？考虑寻求专业帮助。",
    color: "#c026d3"
  },
  controlling_lover: {
    id: "controlling_lover",
    name: "控制关爱型",
    emoji: "🔒",
    description: "以爱之名进行控制，希望掌控伴侣的一切，认为这是关心。",
    characteristics: ["控制欲强", "监控倾向", "限制自由", "以爱为名"],
    strengths: ["高度投入关系", "责任感强"],
    challenges: ["控制破坏关系", "伴侣感到窒息", "需要反思控制动机"],
    advice: "真正的爱是信任和自由，不是控制。控制源于你的不安，而非对方的问题。如果控制行为影响了关系，可以考虑寻求情感咨询的帮助。",
    color: "#a21caf"
  },
  possessive_intense: {
    id: "possessive_intense",
    name: "强烈占有型",
    emoji: "⛓️",
    description: "占有欲极强，四个维度都高，关系可能不健康，需要警惕。",
    characteristics: ["极度控制", "强烈嫉妒", "完全依赖", "深度不安"],
    strengths: ["爱得深刻", "忠诚度高"],
    challenges: ["关系可能不健康", "双方都可能受伤", "可能源于心理创伤"],
    advice: "如果你的占有欲已经严重影响了关系质量和日常生活，可以考虑寻求专业心理咨询的帮助。健康的爱应该让双方都感到舒适和自由。",
    color: "#be123c"
  },
  obsessive_lover: {
    id: "obsessive_lover",
    name: "痴迷执着型",
    emoji: "🌪️",
    description: "对伴侣近乎痴迷，爱到极致却可能伤害关系。",
    characteristics: ["痴迷程度高", "难以自控", "情绪极端", "理性缺失"],
    strengths: ["情感强度极高", "愿意牺牲一切"],
    challenges: ["失去自我", "关系压力大", "情绪管理困难"],
    advice: "这种程度的占有欲可能源于深层心理问题或创伤。如果感到难以控制或影响了生活，专业心理咨询可能会对你和伴侣都有帮助。",
    color: "#9f1239"
  },
  codependent_fused: {
    id: "codependent_fused",
    name: "共依存融合型",
    emoji: "🔗",
    description: "与伴侣共依存，界限模糊，失去自我，需要重建独立性。",
    characteristics: ["无法分离", "界限模糊", "自我消失", "过度依赖"],
    strengths: ["关系紧密"],
    challenges: ["共依存关系", "双方都可能不健康", "需要重建自我"],
    advice: "共依存是一种需要关注的关系模式。你可以阅读《共依存症》相关书籍了解更多。如果影响到你的生活质量，专业心理咨询可能会有帮助。",
    color: "#881337"
  },
  paranoid_suspicious: {
    id: "paranoid_suspicious",
    name: "多疑猜忌型",
    emoji: "🔍",
    description: "极度不信任，过度猜疑，可能有偏执倾向，严重影响关系。",
    characteristics: ["极度多疑", "不信任", "过度监控", "关系紧张"],
    strengths: ["警觉性高"],
    challenges: ["信任完全缺失", "关系难以维系", "情绪困扰较大"],
    advice: "这种程度的猜疑可能会严重影响生活。如果伴有焦虑、失眠等其他症状，可以考虑到心理科或精神科咨询，专业人士可以帮助评估和改善。",
    color: "#831843"
  }
}

// 依恋类型定义（完整版）
export const ATTACHMENT_TYPES = {
  secure: {
    name: "安全型依恋",
    emoji: "🌟",
    description: {
      self: "你在恋爱关系中感到安全和舒适，能够平衡亲密与独立。这是最健康的依恋类型。",
      partner: "Ta在你们的关系中感到安全和舒适，能够平衡亲密与独立。这是最健康的依恋类型。"
    },
    secondaryDescription: {
      self: "你表现出部分安全型特质，这是积极的信号。继续保持这种健康的关系模式。",
      partner: "Ta表现出部分安全型特质，这是积极的信号。珍惜Ta在关系中的成熟表现。"
    },
    characteristics: ["情感稳定成熟", "信任能力强", "沟通开放坦诚", "平衡亲密与空间"],
    relationshipPattern: {
      self: "你在恋爱中表现出信任和支持，既能享受亲密，也尊重彼此的独立性。这样的关系通常稳定长久。",
      partner: "Ta在与你的关系中表现出信任和支持，既能享受亲密，也尊重你的独立性。你们的关系通常稳定长久。"
    },
    strengthsInLove: ["能够建立深度亲密关系", "信任伴侣，不过度猜疑", "有效沟通情感需求", "关系冲突时理性处理", "支持伴侣个人成长"],
    challenges: ["可能遇到依恋不安全的伴侣时需要更多耐心", "需要意识到不是所有人都有同样的安全感"],
    advice: {
      self: "你的依恋模式很健康！继续保持开放沟通和相互支持。如果伴侣是焦虑型或回避型，给予更多理解和安全感。",
      partner: "Ta的依恋模式很健康，这是理想的伴侣类型。珍惜Ta的成熟稳定，你们有很好的关系基础。"
    },
    color: "#3b82f6"
  },
  anxious: {
    name: "焦虑型依恋",
    emoji: "😰",
    description: {
      self: "你在恋爱关系中容易焦虑不安，害怕被抛弃，需要频繁确认伴侣的爱意。",
      partner: "Ta在你们的关系中容易焦虑不安，害怕被你抛弃，需要频繁确认你的爱意。"
    },
    secondaryDescription: {
      self: "你也表现出一些焦虑倾向，可能需要更多的安全感确认。学习自我安慰技巧会有帮助。",
      partner: "Ta也表现出一些焦虑倾向，可能需要你更多的安全感确认。保持行为的稳定性和可预测性会让Ta更安心。"
    },
    characteristics: ["情感需求高", "害怕被抛弃", "需要持续确认", "情绪波动较大"],
    relationshipPattern: {
      self: "你在恋爱中表现得特别在乎对方，但也容易因小事焦虑。可能出现过度依赖、频繁联系、需要安慰等行为。",
      partner: "Ta在与你的关系中表现得特别在乎你，但也容易因小事焦虑。Ta可能会过度依赖你、频繁联系你、需要你的安慰。"
    },
    strengthsInLove: ["情感投入度高", "重视关系质量", "敏感细腻，善于觉察", "愿意为关系付出", "忠诚度高"],
    challenges: ["容易过度焦虑和担心", "可能给伴侣带来压力", "情绪消耗大", "容易陷入负面循环", "可能吸引回避型伴侣"],
    advice: {
      self: "学习自我安慰和情绪调节技巧。建立内在安全感，不要只依赖外部确认。你可以阅读《依恋理论》相关书籍了解更多。如果焦虑严重影响生活，心理咨询可能会有帮助。",
      partner: "给予Ta更多的安全感和确认。保持你行为的稳定性，经常向Ta表达爱意。理解Ta的焦虑不是故意的，耐心陪伴Ta成长。如果你感到压力过大，可以考虑一起寻求情感咨询。"
    },
    color: "#f59e0b"
  },
  avoidant: {
    name: "回避型依恋",
    emoji: "🚪",
    description: {
      self: "你在恋爱关系中倾向于保持距离，珍视独立，过度亲密让你感到不适。",
      partner: "Ta在你们的关系中倾向于保持距离，珍视独立，过度亲密让Ta感到不适。"
    },
    secondaryDescription: {
      self: "你也有一些回避倾向，当关系过于亲密时可能会感到不适。尝试逐步练习情感表达。",
      partner: "Ta也有一些回避倾向，当你们过于亲密时Ta可能会感到不适。给Ta一些个人空间，用行动而非言语表达关心。"
    },
    characteristics: ["情感疏离", "重视独立", "避免亲密", "自我保护强"],
    relationshipPattern: {
      self: "你在恋爱中可能表现得冷淡或疏离，不喜欢过多的情感表达和身体接触。当关系过于亲密时你会感到窒息，需要空间。",
      partner: "Ta在与你的关系中可能表现得冷淡或疏离，不太喜欢过多的情感表达和身体接触。当你们过于亲密时Ta会感到窒息，需要个人空间。"
    },
    strengthsInLove: ["独立性强", "不会过度依赖", "给伴侣自由空间", "情绪稳定理性", "善于自我调节"],
    challenges: ["难以建立深度亲密", "情感表达困难", "可能伤害渴望亲密的伴侣", "容易在关系深入时退缩", "可能吸引焦虑型伴侣"],
    advice: {
      self: "尝试逐步练习情感表达和亲密接触。理解亲密不等于失去自我。如果你发现回避模式影响了关系质量，心理咨询可以帮助你探索回避的根源。",
      partner: '尊重Ta对个人空间的需求，不要过度追逐Ta。用行动而非言语表达你的关心。给Ta时间慢慢打开心扉。如果你们经常陷入"追逃模式"，可以考虑一起学习依恋理论或寻求情感咨询。'
    },
    color: "#06b6d4"
  },
  fearful: {
    name: "恐惧型依恋（混乱型）",
    emoji: "🌊",
    description: {
      self: "你既渴望亲密又害怕受伤，在恋爱中矛盾纠结，时而靠近伴侣时而推开。",
      partner: "Ta既渴望亲密又害怕受伤，在你们的关系中矛盾纠结，时而靠近你时而推开你。"
    },
    secondaryDescription: {
      self: "你表现出强烈的焦虑和恐惧，这可能源于过往创伤。如果这些情绪严重影响了你的生活，专业心理帮助可能会有用。",
      partner: "Ta表现出强烈的焦虑和恐惧，这可能源于过往创伤。如果这些情绪严重影响了你们的关系，可以考虑一起寻求专业帮助。"
    },
    characteristics: ["矛盾纠结", "渴望又恐惧", "情绪不稳定", "难以信任"],
    relationshipPattern: {
      self: "你在恋爱中表现出矛盾行为：时而热情依恋，时而冷漠疏离。你内心渴望亲密但又害怕被伤害，导致关系起伏不定。",
      partner: "Ta在与你的关系中表现出矛盾行为：时而热情依恋你，时而对你冷漠疏离。Ta内心渴望亲密但又害怕被伤害，导致你们的关系起伏不定。"
    },
    strengthsInLove: ["情感深度", "能够深刻理解痛苦", "有改变的强烈动机", "敏感细腻"],
    challenges: ["关系模式混乱不稳定", "难以建立持久关系", "容易陷入痛苦循环", "可能出现极端行为", "双方都很痛苦"],
    advice: {
      self: "这种依恋模式通常源于童年创伤或不一致的养育。如果关系中的矛盾让你感到痛苦，专业心理咨询或治疗（如EMDR、创伤聚焦疗法等）可能会有帮助。你也可以阅读《依恋与亲密关系：伴侣沟通的七种EFT对话》了解更多。",
      partner: "Ta的依恋模式可能源于童年创伤。这段关系对你会很有挑战性，需要你极大的耐心和理解。如果你们的关系让双方都感到痛苦，可以考虑一起寻求专业情感咨询。记得也要照顾好自己的情绪。"
    },
    color: "#8b5cf6"
  }
}

/**
 * 计算维度得分
 * @param {Object} answers - 答案对象 { questionId: value }
 * @param {Array} questions - 题目数组
 * @returns {number} 维度得分
 */
function calculateDimensionScore(answers, questions) {
  let totalScore = 0
  let answeredCount = 0
  
  questions.forEach(question => {
    const answer = answers[question.id]
    if (answer !== undefined) {
      totalScore += answer
      answeredCount++
    }
  })
  
  return answeredCount > 0 ? totalScore : 0
}

/**
 * 计算Z分数
 * @param {number} rawScore - 原始分数
 * @param {number} mean - 平均分
 * @param {number} sd - 标准差
 * @returns {number} Z分数
 */
function calculateZScore(rawScore, mean, sd) {
  return sd === 0 ? 0 : (rawScore - mean) / sd
}

/**
 * 标准正态分布的累积分布函数（近似）
 * 使用误差函数近似计算
 * @param {number} z - Z分数
 * @returns {number} 累积概率（0-1）
 */
function standardNormalCDF(z) {
  const sign = z < 0 ? -1 : 1
  const absZ = Math.abs(z) / Math.sqrt(2)
  const t = 1 / (1 + 0.3275911 * absZ)
  const erf = 1 - ((((1.061405429 * t + -1.453152027) * t + 1.421413741) * t + -0.284496736) * t + 0.254829592) * t * Math.exp(-absZ * absZ)
  return 0.5 * (1 + sign * erf)
}

/**
 * 计算RPI总分
 * @param {Object} dimensionScores - 各维度Z分数
 * @returns {number} RPI总分（0-100）
 */
function calculateRPIScore(dimensionScores) {
  const { controlDesire, jealousyIntensity, emotionalDependence, relationshipInsecurity } = dimensionScores
  
  // 四个维度的平均Z分数
  const averageZScore = (controlDesire + jealousyIntensity + emotionalDependence + relationshipInsecurity) / 4
  
  // 将Z分数转换为百分位数
  const percentile = 100 * standardNormalCDF(averageZScore)
  
  // 确保分数在0-100范围内
  return Math.round(Math.max(0, Math.min(100, percentile)))
}

/**
 * 获取RPI等级信息
 * @param {number} rpiScore - RPI分数
 * @returns {Object} 等级信息
 */
export function getRPILevel(rpiScore) {
  return RPI_LEVELS.find(level => rpiScore >= level.min && rpiScore <= level.max) || RPI_LEVELS[2]
}

/**
 * 根据四维度Z分数判断人格类型
 * 基于源网站的判断逻辑（完全按照 docs/index.js 第 8411 行的逻辑）
 * @param {Object} dimensionZScores - 各维度Z分数 { controlDesire, jealousyIntensity, emotionalDependence, relationshipInsecurity }
 * @returns {Object} 人格类型对象
 */
export function getPersonalityType(dimensionZScores) {
  const { controlDesire: s, jealousyIntensity: t, emotionalDependence: r, relationshipInsecurity: a } = dimensionZScores
  
  // 计算四维度平均Z分数
  const l = (s + t + r + a) / 4
  
  // 创建维度数组并排序，找出得分最高的维度
  const dimensions = [
    { name: "control", score: s },
    { name: "jealousy", score: t },
    { name: "dependency", score: r },
    { name: "insecurity", score: a }
  ].sort((e, s) => s.score - e.score)
  
  const n = dimensions[0].name
  
  // 完全按照源网站的逻辑进行判断
  // 源网站逻辑：l < -.5 ? s < -1 && t < -1 ? to : .8 > Math.abs(l) ? td : a < -1 ? tm : tx : l < .5 ? a > .5 ? tg : t > .5 ? tu : r > .5 ? tp : th : l < 1.5 ? "jealousy" === n ? tf : "dependency" === n ? ty : "control" === n ? tN : tj : "control" === n && s > 2 ? tb : "dependency" === n && r > 2 ? tw : "insecurity" === n && a > 2 ? tk : l > 2 ? tv : tb
  
  if (l < -0.5) {
    if (s < -1 && t < -1) {
      return PERSONALITY_TYPES.free_spirit // to - 自由灵魂型
    } else if (0.8 > Math.abs(l)) {
      return PERSONALITY_TYPES.balanced_trust // td - 平衡信任型
    } else if (a < -1) {
      return PERSONALITY_TYPES.rational_observer // tm - 理性观察型
    } else {
      return PERSONALITY_TYPES.gentle_companion // tx - 温柔陪伴型
    }
  } else if (l < 0.5) {
    if (a > 0.5) {
      return PERSONALITY_TYPES.insecure_seeker // tg - 不安寻求型
    } else if (t > 0.5) {
      return PERSONALITY_TYPES.selective_jealous // tu - 选择性嫉妒型
    } else if (r > 0.5) {
      return PERSONALITY_TYPES.caring_worrier // tp - 关心忧虑型
    } else {
      return PERSONALITY_TYPES.mild_protector // th - 轻度保护型
    }
  } else if (l < 1.5) {
    if (n === "jealousy") {
      return PERSONALITY_TYPES.jealous_guardian // tf - 嫉妒守护型
    } else if (n === "dependency") {
      return PERSONALITY_TYPES.anxious_attacher // ty - 焦虑依恋型
    } else if (n === "control") {
      return PERSONALITY_TYPES.controlling_lover // tN - 控制关爱型
    } else {
      return PERSONALITY_TYPES.passionate_lover // tj - 热情深情型
    }
  } else {
    if (n === "control" && s > 2) {
      return PERSONALITY_TYPES.possessive_intense // tb - 强烈占有型
    } else if (n === "dependency" && r > 2) {
      return PERSONALITY_TYPES.codependent_fused // tw - 共依存融合型
    } else if (n === "insecurity" && a > 2) {
      return PERSONALITY_TYPES.paranoid_suspicious // tk - 多疑猜忌型
    } else if (l > 2) {
      return PERSONALITY_TYPES.obsessive_lover // tv - 痴迷执着型
    } else {
      return PERSONALITY_TYPES.possessive_intense // tb - 强烈占有型（默认）
    }
  }
}

/**
 * 推断依恋类型（完全按照源网站的评分算法）
 * @param {Object} dimensionZScores - 各维度Z分数 { controlDesire, jealousyIntensity, emotionalDependence, relationshipInsecurity }
 * @returns {Object} 依恋类型结果 { primary, secondary, scores }
 */
function inferAttachmentType(dimensionZScores) {
  const { controlDesire: s, jealousyIntensity: t, emotionalDependence: r, relationshipInsecurity: a } = dimensionZScores
  
  // 完全按照源网站逻辑计算得分
  const attachmentScores = [
    {
      type: "secure",
      // 安全型：所有维度的Z分数都接近0时得分高
      score: (1 - Math.min(1, Math.abs(s) / 2)) * 25 + 
             (1 - Math.min(1, Math.abs(t) / 2)) * 25 + 
             (1 - Math.min(1, Math.abs(r) / 2)) * 20 + 
             (1 - Math.min(1, Math.abs(a) / 2)) * 30
    },
    {
      type: "anxious",
      // 焦虑型：嫉妒、依赖、不安全感高时得分高
      score: 25 * Math.max(0, t) + 
             25 * Math.max(0, r) + 
             30 * Math.max(0, a) + 
             20 * Math.max(0, s)
    },
    {
      type: "avoidant",
      // 回避型：依赖低、嫉妒低、不安低时得分高
      score: 30 * Math.max(0, -r) + 
             25 * Math.max(0, -t) + 
             25 * Math.max(0, -a) + 
             (s < -0.5 ? 20 * Math.abs(s) : 0)
    },
    {
      type: "fearful",
      // 恐惧型：不安感极高，控制欲高，依赖矛盾
      score: 35 * Math.max(0, a) + 
             25 * Math.max(0, s) + 
             (Math.abs(r) > 1 ? 20 * Math.abs(r - 1) : 0) + 
             20 * Math.max(0, t)
    }
  ]
  
  // 按得分排序（从高到低）
  attachmentScores.sort((a, b) => b.score - a.score)
  
  const primaryType = attachmentScores[0]
  const secondaryType = attachmentScores[1]
  const thirdType = attachmentScores[2]
  const fourthType = attachmentScores[3]
  
  // 计算基准分数（用于调整低分类型）
  const baseScore = (primaryType.score + secondaryType.score) * 0.25
  
  // 构建最终得分对象（完全按照源网站逻辑）
  const finalScores = {
    [primaryType.type]: primaryType.score,
    [secondaryType.type]: secondaryType.score,
    [thirdType.type]: Math.max(baseScore, thirdType.score),
    [fourthType.type]: Math.max(0.8 * baseScore, fourthType.score)
  }
  
  // 判断是否有次要类型（次要类型得分需要超过主要类型的60%）
  const hasSecondary = secondaryType.score > 0.6 * primaryType.score
  
  return {
    primary: primaryType.type,
    secondary: hasSecondary ? secondaryType.type : undefined,
    scores: finalScores
  }
}

/**
 * 计算完整的评估结果
 * @param {Object} answers - 答案对象
 * @param {Object} questionnaireData - 问卷数据
 * @param {string} type - 测评类型（self/partner）
 * @param {number} zodiacSign - 星座编号（1-12，0表示未选择）
 * @returns {Object} 完整的评估结果
 */
export function calculateResults(answers, questionnaireData, type = 'self', zodiacSign = 0) {
  const dimensions = questionnaireData[type].dimensions
  
  // 计算各维度原始分数
  const rawScores = {}
  dimensions.forEach(dimension => {
    rawScores[dimension.id] = calculateDimensionScore(answers, dimension.questions)
  })
  
  // 维度参数（均值和标准差）- 基于大样本数据
  const dimensionParams = {
    cd_self: { mean: 25, sd: 7.5 },
    cd_partner: { mean: 25, sd: 7.5 },
    ji_self: { mean: 27.5, sd: 8 },
    ji_partner: { mean: 27.5, sd: 8 },
    ed_self: { mean: 20, sd: 6.5 },
    ed_partner: { mean: 20, sd: 6.5 },
    ri_self: { mean: 22.5, sd: 7 },
    ri_partner: { mean: 22.5, sd: 7 }
  }
  
  // 计算各维度Z分数
  const zScores = {}
  const dimensionResults = []
  
  dimensions.forEach(dimension => {
    const rawScore = rawScores[dimension.id]
    const params = dimensionParams[dimension.id]
    let zScore = calculateZScore(rawScore, params.mean, params.sd)
    
    // 简化的维度ID（去掉_self/_partner后缀）
    const simpleDimensionId = dimension.id.replace(/_self|_partner/, '')
    
    zScores[simpleDimensionId] = zScore
    
    // 计算T分数 (T = 50 + 10 * Z)
    const tScore = 50 + 10 * zScore
    
    dimensionResults.push({
      id: dimension.id,
      name: dimension.name,
      rawScore: rawScore,
      zScore: zScore,
      tScore: tScore,
      description: dimension.description
    })
  })
  
  // 应用星座因子调整（如果选择了星座）
  if (zodiacSign > 0 && zodiacSign <= 12) {
    // 导入星座数据
    // const { zodiacData } = require('../data/zodiacData.js')
    // const zodiacFactors = zodiacData[zodiacSign]?.factors
    // if (zodiacFactors) {
    //   // 应用星座因子到Z分数
    //   zScores.cd = zScores.cd * zodiacFactors.controlFactor
    //   zScores.ji = zScores.ji * zodiacFactors.jealousyFactor
    //   zScores.ed = zScores.ed * zodiacFactors.dependencyFactor
    //   zScores.ri = zScores.ri * zodiacFactors.insecurityFactor
      
    //   // 更新dimensionResults中的Z分数和T分数
    //   dimensionResults.forEach((dimension) => {
    //     const simpleId = dimension.id.replace(/_self|_partner/, '')
    //     if (simpleId === 'cd') {
    //       dimension.zScore = zScores.cd
    //       dimension.tScore = 50 + 10 * zScores.cd
    //     } else if (simpleId === 'ji') {
    //       dimension.zScore = zScores.ji
    //       dimension.tScore = 50 + 10 * zScores.ji
    //     } else if (simpleId === 'ed') {
    //       dimension.zScore = zScores.ed
    //       dimension.tScore = 50 + 10 * zScores.ed
    //     } else if (simpleId === 'ri') {
    //       dimension.zScore = zScores.ri
    //       dimension.tScore = 50 + 10 * zScores.ri
    //     }
    //   })
    // }
  }
  
  // 计算RPI总分
  const rpiScore = calculateRPIScore({
    controlDesire: zScores.cd,
    jealousyIntensity: zScores.ji,
    emotionalDependence: zScores.ed,
    relationshipInsecurity: zScores.ri
  })
  
  // 获取RPI等级
  const rpiLevel = getRPILevel(rpiScore)
  
  // 判断人格类型（基于Z分数）
  const personalityType = getPersonalityType({
    controlDesire: zScores.cd,
    jealousyIntensity: zScores.ji,
    emotionalDependence: zScores.ed,
    relationshipInsecurity: zScores.ri
  })
  
  // 推断依恋类型
  const attachmentTypeResult = inferAttachmentType({
    controlDesire: zScores.cd,
    jealousyIntensity: zScores.ji,
    emotionalDependence: zScores.ed,
    relationshipInsecurity: zScores.ri
  })
  
  // 构建完整的依恋类型对象
  const attachmentType = {
    primary: ATTACHMENT_TYPES[attachmentTypeResult.primary],
    secondary: attachmentTypeResult.secondary ? ATTACHMENT_TYPES[attachmentTypeResult.secondary] : null,
    scores: attachmentTypeResult.scores
  }
  
  // 生成结果解释
  const interpretation = generateInterpretation(rpiScore, rpiLevel, zScores, type)
  
  return {
    rpiScore,
    rpiLevel,
    personalityType,
    dimensionResults,
    zScores,
    attachmentType,
    assessmentType: type,
    interpretation,
    timestamp: new Date().toISOString()
  }
}

/**
 * 生成结果解释
 * @param {number} rpiScore - RPI分数
 * @param {Object} rpiLevel - RPI等级对象
 * @param {Object} zScores - 各维度Z分数
 * @param {string} type - 测评类型（self/partner）
 * @returns {Array} 解释文本数组
 */
export function generateInterpretation(rpiScore, rpiLevel, zScores, type = 'self') {
  const isSelf = type === 'self'
  const subject = isSelf ? '你' : 'Ta'
  const interpretation = []
  
  // 基础分数解释
  interpretation.push(`${subject}的恋爱占有欲指数为 ${rpiScore} 分，处于「${rpiLevel.level}」水平。`)
  
  // 占有欲水平描述
  const levelDescriptions = {
    '很低（自由自在）': isSelf ? 
      '表现出很低的占有欲，倾向于给予伴侣充分的自由空间' : 
      '对你表现出很低的占有欲，倾向于给予你充分的自由',
    '偏低（松弛有度）': isSelf ? 
      '占有欲程度较低，能够保持健康的关系边界' : 
      '对你的占有欲程度较低，能保持适当的关系距离',
    '中等（恰到好处）': isSelf ? 
      '占有欲处于正常范围，既有亲密需求也尊重独立空间' : 
      '对你的占有欲处于正常范围，平衡了亲密与独立',
    '偏高（执着深情）': isSelf ? 
      '表现出较强的占有欲，可能需要更多的安全感确认' : 
      '对你表现出较强的占有欲，可能需要你更多的关注和陪伴',
    '很高（爱到极致）': isSelf ? 
      '占有欲较为强烈，建议关注是否对关系造成过度压力' : 
      '对你的占有欲较为强烈，可能需要更多的安全感和确认'
  }
  
  interpretation.push(`这表明${subject}在恋爱关系中${levelDescriptions[rpiLevel.level]}。`)
  
  // 维度分析
  const highDimensions = []
  if (zScores.cd > 1) highDimensions.push('控制欲望')
  if (zScores.ji > 1) highDimensions.push('嫉妒倾向')
  if (zScores.ed > 1) highDimensions.push('情感依赖')
  if (zScores.ri > 1) highDimensions.push('关系不安')
  
  if (highDimensions.length > 0) {
    interpretation.push(`${isSelf ? '' : 'Ta'}在以下维度上得分较高：${highDimensions.join('、')}。`)
  }
  
  // 总结性描述
  if (isSelf) {
    interpretation.push('这些特点可能影响你在恋爱关系中的行为模式和情感体验。')
  } else {
    interpretation.push('了解这些特点有助于你更好地理解和应对你们恋爱关系中的互动模式。')
  }
  
  return interpretation
}

/**
 * 生成个性化建议
 * @param {Object} result - 完整的结果对象
 * @returns {Array} 建议列表
 */
export function generateRecommendations(result) {
  const { rpiLevel, zScores, assessmentType } = result
  const isSelf = assessmentType === 'self'
  const recommendations = []
  
  // 基于RPI等级的建议
  if (rpiLevel.level === '很高（爱到极致）' || rpiLevel.level === '偏高（执着深情）') {
    if (isSelf) {
      recommendations.push('尝试培养独立的兴趣爱好，增强自我价值感，减少对伴侣的过度依赖。')
      recommendations.push('学习信任和沟通技巧，用开放的对话替代监控和控制行为。')
    } else {
      recommendations.push('给予Ta更多的安全感，通过稳定和可预期的行为建立信任。')
      recommendations.push('温和地设立关系边界，帮助Ta理解健康关系需要双方的独立空间。')
    }
  }
  
  // 基于维度的建议
  if (zScores.cd > 1) {
    if (isSelf) {
      recommendations.push('反思控制欲望的根源，可能与不安全感或过往经历有关。')
    } else {
      recommendations.push('理解Ta的控制行为可能源于深层的不安全感，用爱和耐心应对。')
    }
  }
  
  if (zScores.ji > 1) {
    if (isSelf) {
      recommendations.push('练习情绪管理，当嫉妒情绪出现时，先冷静思考再做出反应。')
    } else {
      recommendations.push('主动展现忠诚和专一，减少可能引发Ta嫉妒的行为。')
    }
  }
  
  if (zScores.ri > 1) {
    if (isSelf) {
      recommendations.push('关注自我成长，建立稳固的自尊和自信，减少对关系的焦虑。')
    } else {
      recommendations.push('经常表达对Ta的爱意和承诺，帮助Ta建立关系安全感。')
    }
  }
  
  // 通用建议
  if (isSelf) {
    recommendations.push('与伴侣进行开放诚实的沟通，分享你的感受和需求。')
    recommendations.push('如果占有欲影响了关系质量或让你感到困扰，可以考虑寻求专业情感咨询的帮助。')
  } else {
    recommendations.push('保持耐心和理解，健康的关系需要双方共同努力和成长。')
    recommendations.push('如果Ta的占有欲严重影响了你们的生活质量，可以考虑一起寻求专业情感咨询的帮助。')
  }
  
  recommendations.push('记住这不是诊断工具，结果仅供参考和自我了解。')
  
  return recommendations
}

/**
 * 生成专家建议（维度级别的详细建议）
 * @param {Object} result - 评估结果对象
 * @returns {Array} 专家建议数组
 */
export function generateExpertRecommendations(result) {
  const { assessmentType, zScores } = result
  const isSelf = assessmentType === 'self'
  const expertRecommendations = []
  
  // 使用Z分数来判断是否需要建议（更准确）
  // 当Z分数 > 1 时（即高于平均值1个标准差），显示对应建议
  
  // 控制欲望管理 - 当Z分数 > 1 时显示
  if (zScores.cd > 1) {
    expertRecommendations.push({
      title: '控制欲望管理',
      icon: 'control',
      color: 'psychology-primary',
      advice: isSelf 
        ? '你表现出较高的控制倾向。心理学研究表明，过度控制往往源于内心的不安全感。建议：①反思控制欲的根源，可能与童年经历或过往感情创伤有关；②学习信任的艺术，给予伴侣适当的自由空间；③用开放对话替代监控，表达需求而非控制行为；④培养自己的兴趣爱好，建立独立的生活圈子。'
        : 'Ta对你表现出较高的控制倾向。这可能源于深层的不安全感或过往被背叛的经历。建议：①给予Ta更多的安全感，通过你稳定一致的行为建立信任；②温和地设立边界，用"我需要..."而非"你不能..."的方式与Ta沟通；③理解Ta控制背后的恐惧，用爱和耐心应对；④帮助Ta建立自信，肯定Ta的价值。'
    })
  }
  
  // 嫉妒情绪调节 - 当Z分数 > 1 时显示
  if (zScores.ji > 1) {
    expertRecommendations.push({
      title: '嫉妒情绪调节',
      icon: 'jealousy',
      color: 'psychology-secondary',
      advice: isSelf
        ? '你的嫉妒倾向较为明显。适度嫉妒是在乎的表现，但过度嫉妒会伤害关系。建议：①练习情绪觉察，当嫉妒出现时先暂停、深呼吸、思考；②挑战嫉妒思维："Ta和异性说话"不等于"Ta不爱我"；③提升自我价值感，相信自己值得被爱；④与伴侣坦诚沟通感受，而非指责质问；⑤了解嫉妒是正常情绪，但可以选择如何回应。'
        : 'Ta对你表现出较强的嫉妒倾向。这反映了Ta对你们关系的重视，也暴露了Ta内心的不安。建议：①主动向Ta报备行程，减少不必要的猜测；②避免引发Ta嫉妒的行为（如频繁称赞异性）；③当Ta嫉妒时，先共情理解Ta的感受，再温和解释；④经常向Ta表达专一和忠诚，用行动证明你的爱；⑤如果Ta的嫉妒已严重影响你们的生活质量，可以考虑一起寻求情感咨询。'
    })
  }
  
  // 情感独立成长 - 当Z分数 > 1 时显示
  if (zScores.ed > 1) {
    expertRecommendations.push({
      title: '情感独立成长',
      icon: 'dependency',
      color: 'psychology-accent',
      advice: isSelf
        ? '你对伴侣的情感依赖程度较高。健康的关系需要两个完整的个体。建议：①培养独立的兴趣和朋友圈，丰富你的生活；②练习独处，学会享受一个人的时光；③建立多元的情感支持系统（朋友、家人），不要只依赖伴侣；④提升自我价值感，不要将自我完整性寄托在关系上；⑤学习情绪自我调节，不过度依赖伴侣安慰；⑥阅读共依赖相关书籍，了解健康依恋模式。'
        : 'Ta对你表现出较高的情感依赖。这说明你对Ta很重要，但过度依赖可能成为你们关系的负担。建议：①鼓励Ta发展独立兴趣，支持Ta的个人成长；②避免成为Ta唯一的情感出口，建议Ta拓展社交圈；③温和地拒绝Ta的不合理要求，帮助Ta建立边界感；④给予Ta稳定的关注，但也保留彼此空间；⑤如果Ta的依赖严重影响你们的生活，建议共同寻求专业帮助。'
    })
  }
  
  // 关系安全感建立 - 当Z分数 > 1 时显示
  if (zScores.ri > 1) {
    expertRecommendations.push({
      title: '关系安全感建立',
      icon: 'insecurity',
      color: 'psychology-warning',
      advice: isSelf
        ? '你在关系中存在较强的不安全感。这可能源于焦虑型依恋或过往创伤。建议：①探索不安全感的根源，是童年经历还是过往关系伤害？②挑战"我不够好"的负面信念，列举自己的优点；③练习正念和自我关怀，减少过度担忧；④与伴侣开放沟通不安感受，寻求理解和支持；⑤如果不安全感严重影响生活，可以考虑通过心理咨询获得专业帮助；⑥记录伴侣爱的证据，在焦虑时翻阅提醒自己。'
        : 'Ta在你们的关系中表现出较强的不安全感。这需要你的理解和包容。建议：①经常主动向Ta表达爱意和承诺，用行动给予Ta安全感；②保持你行为的稳定性和可预测性，避免突然的改变；③耐心倾听Ta的担忧，不要轻易否定或嘲笑Ta；④创造安全的沟通环境，让Ta能向你表达脆弱；⑤肯定Ta的价值，帮助Ta建立自信；⑥理解Ta的不安全感不是故意的，需要时间和你的爱来治愈。'
    })
  }
  
  return expertRecommendations
}

